(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Portal.LocalSimon',
                {
                    url: '/LocalSimon',
                    component: 'localSimonComponent',
                });
        }
    ]);

    app.component('localSimonComponent', {
        templateUrl: 'App.Portal/States/Simon/Simon.local.template.html',
    });
})(window.angular, window.app);